export default "__VITE_ASSET__Wn$qxwv1__"